/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {Acceptor_DcDc_Buck} from "./dcdc_buck_acceptor";
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {Utils} from "../../../../common/utils";
import {acceptSingle_common_Iout, acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import {IC_fsw} from "../../../../models/IC_fsw";

export class Acceptor_DcDc_MultiBuck extends Acceptor_DcDc_Buck {
  private acceptSingle_MultiBuck_Iout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): boolean => {
    const ic_out_i = Utils.getFieldValue(ic, "validator.output." + i);
    const ioutMax: number = Utils.getFieldValue(ic_out_i, "iout_max", ic.iout_max);

    return (Utils.isValueEmpty(out.current) || out.current <= ioutMax);
  }

  private acceptSingle_MultiBuck_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): boolean => {
    const dMax = Math.min(new IC_fsw(ic).dMax, 0.98);
    const ic_out_i = Utils.getFieldValue(ic, "validator.output." + i);

    const voutMin: number = Utils.getFieldValue(ic_out_i, "vout_min", ic.vout_min);
    const voutMax: number = Utils.getFieldValue(ic_out_i, "vout_max", ic.vout_max);

    return Utils.isValueEmpty(out.voltage) || (
        ( voutMin <= out.voltage && out.voltage <= voutMax )
        && ( Utils.isValueEmpty(spec.spec.value.input.min) || out.voltage < spec.spec.value.input.min * dMax )
      );
  }

  protected singleOutputV(): AcceptorOutputFn {return andAcceptorSingle([this.acceptSingle_MultiBuck_Vout]); }
  protected singleOutputI(): AcceptorOutputFn {return andAcceptorSingle([this.acceptSingle_MultiBuck_Iout]); }
}
